import WithdrawalExportsPage from './WithdrawalExportsPage';

export default WithdrawalExportsPage;
